module.exports = __webpack_public_path__ + "assets/624cde3a6d4a66f2fad44923d31e5567.png";